<template>
  <master-main
    :addProperties="{
      eventType: 1,
      routeToCreate: getModuleRoute,
    }"
    :exportProperties="{
      pdf: {
        filename: `${$t('common_words.category_record')}.pdf`,
        route: `${getModuleRoute}/pdf`,
      },
      xls: {
        filename: `${$t('common_words.category_record')}.xlsx`,
        route: `${getModuleRoute}/excel`,
      },
    }"
    :route="getModuleRoute"
    :tableProperties="tableProperties"
    @refresh="refresh"
    :showSubcategories="true"
    @showHideLoading="showHideLoading"
    @showNotification="notifyVue"
    ref="masterMain"
    :dataBadges="[
      {
        columnLabel: $t('common_words.sub_category'),
        data: 'subcategories',
        property: 'name',
        minWidth: 250,
      },
    ]"
  >
  </master-main>
</template>
<script>
import MasterMain from 'src/components/Layouts/Masters/MasterMain.vue';
import MixinAlert from 'src/mixins/mixin-alert';
import MixinLoading from 'src/mixins/mixin-loading';
import MixinMain from 'src/mixins/master/mixin-main';
import MixinPermissions from 'src/util/mixinPermissions';
import CategoryTable from './category-table';

export default {
  components: { MasterMain },
  data() {
    return {
      tableProperties: {},
      showProperties: { size: '65%' },
    };
  },
  mixins: [MixinAlert, MixinLoading, MixinMain, MixinPermissions],
  computed: {
    getModuleRoute() {
      return 'assistance/categories';
    },
    buildTableProperties() {
      return {
        tableColumns: [...CategoryTable().tableColumns],
        model: 'category',
        widthColumnStatus: 160,
        widthOperations: 110,
        effectTags: 'dark',
      };
    },
  },
};
</script>
